import { createReducer, on } from '@ngrx/store';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import * as DataActions from './data-type.actions';
import { DataType } from '../../services/model';

export interface DataTypeState extends EntityState<DataType> {
  loading: boolean;
}

export const adapter: EntityAdapter<DataType> = createEntityAdapter<DataType>();

export const initialState: DataTypeState = adapter.getInitialState({
  loading: false,
  error: null,
});

export const dataTypeReducer = createReducer(
  initialState,

  on(DataActions.fetchDataTypes, (state) => ({
    ...state,
    loading: true,
  })),

  on(DataActions.loadDataTypes, (state, { dataTypes }) => adapter.setAll(dataTypes, { ...state, loading: false }))
);
